import { Outlet, useOutletContext } from "react-router-dom";

import { DashboardContent } from "src/layout/DashboardContent";
import { MainSideBar } from "src/mainPage/MainSideBar";

export const CaseDashboard: React.FC = () => {
  const context = useOutletContext();

  return (
    <DashboardContent sidebar={<MainSideBar />} removePadding>
      <Outlet context={context} />
    </DashboardContent>
  );
};
